import React, { useEffect, useState } from "react";
import {
    examtitlelist,
    stuacademicyearlist,
    stuclasslist,
    studivisionlist,
    stusubjectlist,
} from "../../../services/master";
import { AgGridReact } from "ag-grid-react";
import {
    academylist,
    examstudentlist,
    studentclasswiselogs,
    studentclasswiseupload,
    studentexamuploadlogs,
    studentexamwiselogs,
} from "../../../services/admin";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function Bulkexamupload() {
    const navigate = useNavigate();
    const [aclist, setAcList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [ayear, setAYear] = useState("");
    const [alist, setAList] = useState([]);

    const [etitle, setETitle] = useState("");
    const [tlist, setTList] = useState([]);

    const [trecord, setTRecord] = useState(0);
    const [irecord, setIRecord] = useState(0);
    const [urecord, setURecord] = useState(0);
    const [strecord, setStatus] = useState("");
    const [failid, setFailId] = useState(0);

    useEffect(() => {



        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setAcList(arr);
                }
            }
        });


        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                                listyear(arr[0]);
                                setAYear(localStorage.getItem("AYear"));
                            }
                        }

                    }
                }
            });
        } else {
            listyear("");
        }
    }, []);

    const [photoerror, setPhotoError] = useState("");
    const [pfile, setPFile] = useState("");

    function photofile(event) {
        setPhotoError("");
        setPFile("");
        if (event.target.files.length !== 0) {
            if (event.target.files[0].name.match(/\.(xls|xlsx)$/i)) {
                setPFile(event.target.files[0]);
            } else {
                setPhotoError("Upload Excel should be xls or xlsx format");
            }
            var size = event.target.files[0].size / 1024 / 1024;
            if (size > 5) {
                setPhotoError("Upload Excel size should be less than 5MB");
            }
        }
    }

    const [filterProduct, setFilterProduct] = useState([]);
    const columnDefs = [
        {
            headerName: "Upload Excel",
            width: 170,
            field: "excel_name",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            className="excelfailed text-success"
                            href={params.data.path + params.value}
                            download={params.data.path + params.value}
                            target="_blank"
                        >
                            Click to Download
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Failed Excel",
            width: 150,
            field: "id",
            sortable: true,
            resizable: true,
            filter: false,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            className="excelfailed text-danger"
                            onClick={() => failedent(params.value)}
                        >
                            Click to Download
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Uploaded on",
            width: 150,
            field: "created_at",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-yyyy hh:mm:ss A");
                }
            },
        },
        {
            headerName: "Uploaded by",
            width: 150,
            field: "username",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
    ];
    const [errmsg, setErrMsg] = useState("");
    function submitclass() {
        let valid = "";
        setErrMsg("");
        if (localStorage.getItem("Role") === "1") {
            if (acaid === "") {
                setErrMsg("Please Select Academy");
                valid = "Please Select Academy";
            }
        } else {
            valid = "";
        }

        if (ayear !== "") {
            if (etitle !== "") {
                if (valid === "") {
                    setLoading(true);
                    const temp = new FormData();
                    if (localStorage.getItem("Role") === "1" && acaid !== "") {
                        temp.append("academy_id", acaid.value);
                    }
                    temp.append("exam_title", etitle);
                    temp.append("year_id", ayear);
                    temp.append("excel_name", pfile);
                    studentexamuploadlogs(temp).then((response) => {
                        if (response.status === true) {
                            setLoading(false);
                            if (response.data.total_rows !== "") {
                                setTRecord(response.data.total_rows);
                            }
                            if (response.data.inserted_count !== "") {
                                setIRecord(response.data.inserted_count);
                            }
                            if (response.data.failed_count !== "") {
                                setURecord(response.data.failed_count);
                            }
                            setFailId(response.data.uploaded_excel_id);
                            setStatus(response.data.status);
                            listall(acaid, ayear, etitle);
                        } else {
                            setLoading(false);
                            setErrMsg(response.data.join(","));
                        }
                    });
                }
            } else {
                setErrMsg("Please Select Exam Title");
            }

        } else {
            setErrMsg("Please select Academic Year");
        }
    }

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
            listall(e, ayear, etitle);
            listyear(e);
        } else {
            setAcaID("");
            listall("", ayear, etitle);
            listyear("");
        }
    }
    const [sublist, setSubList] = useState([]);
    const [show, setShow] = useState(false);
    function checksub(e) {
        e.preventDefault();
        setShow(true);
    }

    function failedent(fid) {
        window.open(localStorage.getItem("activeBaseUrl") + "/export-exam-failed/" + fid, "_blank");
    }

    function listall(aid, yid, eid) {
        setAYear(yid);
        setETitle(eid);
        if (yid !== "" && eid !== "") {
            const temp = new FormData();
            if (localStorage.getItem("Role") === "1" && aid !== "") {
                temp.append("academy_id", aid.value);
            }
            temp.append("year_id", yid);
            //   temp.append("class_id", cid);
            //   temp.append("section_id", sid);
            temp.append("exam_title", eid);
            studentexamwiselogs(temp).then((response) => {
                if (response.status === true) {
                    setFilterProduct(response.data.details);
                }
            })
        }
    }

    function listyear(aid) {
        setAList([]);
        setAYear("");
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid.value);
        }
        stuacademicyearlist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].aca_year,
                        });
                    }
                    setAList(arr);
                }
            }
        });

        examtitlelist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].exam_title,
                        });
                    }
                    setTList(arr);
                }
            }
        });
        stusubjectlist(temp).then((res) => {
            if (res.status === true) {
                setSubList(res.data);
            }
        });
    }
    const [loading, setLoading] = useState(false);

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                    Exam Upload
                </h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Exam</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Exam Upload
                    </li>
                </ol>
            </div>

            {loading && (
                <div className="loader-wrapper">
                    <div className="loader"></div>
                    <h3>Loading...Please do not go back or close the window.</h3>
                </div>
            )}
            {!loading && (
                <div className="content-body">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h2 className="main-content-title tx-24 mg-b-5">
                                            Exam Upload
                                        </h2>
                                    </div>
                                    <div className="card-body">

                                        <div className="row">
                                            <div className="col-md-6">

                                            </div>
                                            <div className="col-md-6 text-right">
                                                <a className="btn btn-success me-2" onClick={checksub}>
                                                    Subject List
                                                </a>
                                                <a
                                                    className="btn btn-secondary"
                                                    href={require("../../../assets/images/Exam_BulkUpload.xlsx")} download
                                                >
                                                    Download Sample Excel
                                                </a>
                                            </div>
                                            {localStorage.getItem("Role") === "1" && (
                                                <div className="col-xl-6 col-sm-6">
                                                    <div className="mb-3">
                                                        <label className="form-label">
                                                            Select Academy{" "}
                                                            <span className="text-danger"> *</span>
                                                        </label>
                                                        <Select
                                                            className="default-select"
                                                            placeholder="Select Academy"
                                                            value={acaid}
                                                            options={aclist}
                                                            onChange={handleAcademy}
                                                            isSearchable={true}
                                                            isClearable
                                                            hidden
                                                        />
                                                    </div>
                                                </div>
                                            )}

                                            <div className="col-xl-6 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Academic Year{" "}
                                                        <span className="text-danger"> *</span>
                                                    </label>
                                                    <select
                                                        className="default-select  form-control wide"
                                                        onChange={(e) =>
                                                            listall(
                                                                acaid,
                                                                e.target.value,
                                                                etitle
                                                            )
                                                        }
                                                        value={ayear}
                                                    >
                                                        <option value="" disabled>
                                                            Select Academic Year
                                                        </option>
                                                        {alist.map((item) => (
                                                            <option value={item.value} key={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-xl-6 col-sm-6">
                                                <div className="mb-6">
                                                    <label className="form-label">
                                                        Exam Title<span className="text-danger"> *</span>
                                                    </label>
                                                    <select
                                                        className="default-select form-control wide"
                                                        onChange={(e) =>
                                                            listall(
                                                                acaid,
                                                                ayear,
                                                                e.target.value
                                                            )
                                                        }
                                                        value={etitle}
                                                    >
                                                        <option value="" disabled>
                                                            Select Exam Title
                                                        </option>
                                                        {tlist.map((item) => (
                                                            <option value={item.value} key={item.value}>
                                                                {item.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-xl-6 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Upload Excel<span className="text-danger"> *</span>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        className="form-control buttion-file"
                                                        accept=".xlsx, .xls"
                                                        onChange={(e) => photofile(e)}
                                                    />
                                                    {photoerror && (
                                                        <span className="text-danger">{photoerror}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        {errmsg !== "" && (
                                            <span className="text-danger">{errmsg}</span>
                                        )}

                                        <div className="res-right mt-2 me-4">
                                            <a
                                                className="btn btn-secondary me-2"
                                                onClick={()=>navigate("/exam/listallexams")}
                                            >
                                                Back
                                            </a>
                                            <button
                                                className="btn btn-success"
                                                onClick={submitclass}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Modal show={show} size="md">
                                <Modal.Header>
                                    <Modal.Title>Subject List</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-striped pointstable">
                                            <thead>
                                                <tr>
                                                    <th>SNo</th>
                                                    <th>Subject</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {sublist.map((item, i) => (
                                                    <tr key={item.id}>
                                                        <td className="text-center">{i + 1}</td>

                                                        <td className="text-center">{item.subject_name}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShow(false)}
                                    >
                                        Close
                                    </button>
                                </Modal.Footer>
                            </Modal>

                            <div className="col-lg-12 mt-2">
                                <div className="card custom-card mg-b-20">
                                    <div className="card-body">
                                        <div className="card-header">
                                            <h2 className="main-content-title tx-24 mg-b-5">
                                                Upload Preview
                                            </h2>
                                        </div>

                                        <div className="row row-cards mt-1">
                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                <div className="card bg-custom">
                                                    <div className="card-body text-center feature">
                                                        <p className="card-text mt-2">
                                                            <strong>Total Records</strong>
                                                        </p>
                                                        <p className="h3 text-center text-info">
                                                            {trecord}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                <div className="card bg-custom">
                                                    <div className="card-body text-center feature">
                                                        <p className="card-text mt-2">
                                                            <strong>Inserted Records</strong>
                                                        </p>
                                                        <p className="h3 text-center text-success">
                                                            {irecord}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                <div className="card bg-custom">
                                                    <div className="card-body text-center feature">
                                                        <p className="card-text mt-2">
                                                            <strong>Failed Records</strong>
                                                        </p>
                                                        <p className="h3 text-center text-danger">
                                                            {urecord}
                                                        </p>
                                                        {urecord !== 0 && (
                                                            <a
                                                                className="excelfailed text-danger"
                                                                onClick={() => failedent(failid)}
                                                            >
                                                                <b>Click to Download</b>
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
                                                <div className="card bg-custom">
                                                    <div className="card-body text-center feature">
                                                        <p className="card-text mt-2 mb-3">
                                                            <strong>Upload Status</strong>
                                                        </p>
                                                        {strecord === "Success" && (
                                                            <p className="badge badge-success">
                                                                <b>{strecord}</b>
                                                            </p>
                                                        )}
                                                        {strecord !== "Success" && (
                                                            <p className="badge badge-danger">
                                                                <b>{strecord}</b>
                                                            </p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="ag-theme-alpine ag-style mt-2">
                                            <AgGridReact
                                                columnDefs={columnDefs}
                                                rowData={filterProduct}
                                                pagination="true"
                                                paginationPageSize="10"
                                                sortingOrder={["asc", "desc"]}
                                                suppressDragLeaveHidesColumns={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
